import Model from '@/models/Model.js';

export default class LogicalAttendanceWeek extends Model {
    static entity = 'logical_attendance_weeks';

    static modelName = 'LogicalAttendanceWeek';

    static fields() {
        return {
            id: this.attr(null),
            course_id: this.attr(null),
            week_start: this.attr(null),
            week_end: this.attr(null),

            ...super.fields(),

            course: this.belongsTo('courses', 'course_id'),
        };
    }

    get title() {
        const start = this.timestamp('week_start').format('MMMM D, YYYY');
        const end = this.timestamp('week_end').format('MMMM D, YYYY');

        return `${start} - ${end}`;
    }

    get range_filter() {
        return {
            weekStart: this.timestamp('week_start').format('MM/DD/Y'),
            weekEnd: this.timestamp('week_end').format('MM/DD/Y'),
        };
    }
}
